import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Content,
  Details,
  Grid,
  Row,
} from './styles';

class Referrals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalReferrals: 0,
    };
  }

  componentDidMount() {
    let { totalReferrals } = this.state;
    this.props.referrals.forEach((referral) => {
      totalReferrals += referral.user.testers.length;
    });
    this.setState({ totalReferrals });
  }

  render() {
    return (
      <Container>
        <Details>
          Total Referrals:
          {this.state.totalReferrals}
        </Details>
        {this.props.referrals.map((referral) => {
          if (!_.isEmpty(referral.user.testers)) {
            return (referral.user.testers.map((tester) => (
              <Content key={referral.id}>
                <Grid>
                  <Row>
                    <Column weight={500} width={3}>
                      <ColumnName>
                        Company
                      </ColumnName>
                    </Column>
                    <Column width={12}>
                      <ColumnValue>
                        {tester.project.company.name}
                      </ColumnValue>
                    </Column>
                  </Row>
                  <Row>
                    <Column weight={500} width={3}>
                      <ColumnName>
                        Project
                      </ColumnName>
                    </Column>
                    <Column width={12}>
                      <ColumnValue>
                        {tester.project.name}
                      </ColumnValue>
                    </Column>
                  </Row>
                  <Row>
                    <Column weight={500} width={3}>
                      <ColumnName>
                        Referred Person
                      </ColumnName>
                    </Column>
                    <Column width={12}>
                      <ColumnValue>
                        {referral.firstName}
                        {' '}
                        {referral.firstName}
                      </ColumnValue>
                    </Column>
                  </Row>
                </Grid>
              </Content>
            ))
            );
          }
          return null;
        })}
      </Container>
    );
  }
}

Referrals.propTypes = {
  referrals: PropTypes.array.isRequired,
};

export default Referrals;
